/**
 * Created by abbeymart on 2016-12-26.
 */
import type { RouteRecordRaw } from 'vue-router';

export const favouriteRoutes: Array<RouteRecordRaw> = [
  {
    path: '/favourite',
    name: 'favourite',
    component: () => import('pages/central/common/McFavourite.vue'),
    meta: {
      title: 'Favourites - Fast Links',
    },
  },
];
